<div class="default-content" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}">
  <!--<img class="center-block full-logo" logo />-->
  <img class="center-block full-logo" [src]="logo" />

  <br>

  <auth-login-form (onSubmit)="onFormSubmited($event)"></auth-login-form>

  <!--<p class="text-center"><a (click)="onForgotPasswordClickedEvent()" routerLink="/auth/forgot-password" class="notice-text notice-link">{{ 'FPW.FORGOT_PASSWORD' | translate }}?</a></p>-->
  <p class="text-center"><a (click)="onForgotPasswordClickedEvent()" class="notice-text notice-link">{{ 'FPW.FORGOT_PASSWORD' | translate }}?</a></p>
</div>